module.exports = __webpack_public_path__ + "static/cat_2-536a6c1837f1317a55e0565285b589bf.png";